import { EnumColorsButton } from './types';

export const BUTTON_COLOR_OPTIONS = {
  default: EnumColorsButton.default,
  primary: EnumColorsButton.primary,
  secondary: EnumColorsButton.secondary,
  tertiary: EnumColorsButton.tertiary,
  quaternary: EnumColorsButton.quaternary,
  quinary: EnumColorsButton.quinary,
  senary: EnumColorsButton.senary,
  septenary: EnumColorsButton.septenary,
  octonary: EnumColorsButton.octonary,
  nonary: EnumColorsButton.nonary,
  denary: EnumColorsButton.denary,
  undecenary: EnumColorsButton.undecenary,
  duodecenary: EnumColorsButton.duodecenary,
  tredecenary: EnumColorsButton.tredecenary,
  quattuordecenary: EnumColorsButton.quattuordecenary,
  quindecenary: EnumColorsButton.quindecenary,
  sexdecenary: EnumColorsButton.sexdecenary,
};
